<template>
  <!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
       y="0px"
       viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
    <g>
      <g>
        <g>
          <path d="M480,96H128c-17.673,0-32,14.327-32,32v352c0,17.673,14.327,32,32,32h352c17.673,0,32-14.327,32-32V128
            C512,110.327,497.673,96,480,96z M480,480H128V128h352V480z" />
          <path
            d="M32,32h352v32h32V32c0-17.673-14.327-32-32-32H32C14.327,0,0,14.327,0,32v352c0,17.673,14.327,32,32,32h32v-32H32V32z" />
          <path d="M176,400h256c8.836,0.051,16.041-7.07,16.093-15.907c0.025-4.299-1.681-8.426-4.733-11.453l-64-64
            c-6.241-6.204-16.319-6.204-22.56,0l-20.8,20.8l-52.64-52.64c-6.241-6.204-16.319-6.204-22.56,0l-96,96
            c-6.186,6.31-6.087,16.44,0.223,22.626C167.959,398.304,171.889,399.942,176,400z" />
          <circle cx="384" cy="240" r="32" />
        </g>
      </g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "ImageIcon",
};
</script>
